import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/button';
import { Home, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import StaffPageHeader from '../../../components/StaffPageHeader';
import { clearStaffSession, requestStaffLogout } from '../../../utils/runtimeConfig';
import { AppShell, PageContainer } from '../../../features/ui-system';

export default function AdminPackageMenuLayout({
  title,
  subtitle = '',
  eyebrow = 'Manajemen Paket',
  children,
}) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await requestStaffLogout();
    clearStaffSession();
    toast.success('Logout berhasil');
    navigate('/dadu/login');
  };

  return (
    <AppShell className="package-management-theme">
      <PageContainer>
          <StaffPageHeader
            eyebrow={eyebrow}
            title={title}
            subtitle={subtitle}
            titleClassName="text-white"
            subtitleClassName="text-cyan-100/90"
            actions={(
              <>
                <Link to="/dadu">
                  <Button variant="outline" className="btn-secondary">
                    <Home className="w-4 h-4 mr-2" />Dashboard
                  </Button>
                </Link>
                <Button variant="outline" className="btn-secondary" onClick={handleLogout}>
                  <LogOut className="w-4 h-4 mr-2" />Logout
                </Button>
              </>
            )}
          />
          <div className="mt-5 package-management-content">{children}</div>
      </PageContainer>
    </AppShell>
  );
}
